const welcomeModule = document.querySelector('.sc-welcome-module');
if (welcomeModule) {
  welcomeModule.querySelectorAll('.region-map__area').forEach((area) => {
    area.addEventListener('click', () => {
      welcomeModule.querySelectorAll('.region-map__area').forEach((el) => el.classList.remove('is-active'));
      area.classList.add('is-active');
    });
  });

  attachEvent('.btn-age-confirm', 'click', () => {
    Cookies.set('age-confirmed', true, { expires: new Date('9999-12-31T23:59:59Z') });
    welcomeModule.classList.remove('is-open');
    toggleBodyScrollLock(false);
  });

  if (!Cookies.get('age-confirmed')) {
    welcomeModule.classList.add('is-open');
    toggleBodyScrollLock(true);
  }
}
